document.addEventListener('DOMContentLoaded', function () {
  const inputs = document.querySelectorAll('input.to-halfwidth');

  inputs.forEach(function (input) {
    input.addEventListener('input', function () {
      this.value = this.value
        .replace(/[！-～]/g, function (ch) {
          return String.fromCharCode(ch.charCodeAt(0) - 0xFEE0);
        })
        .replace(/　/g, ' ');
    });
  });
});